// extracted by mini-css-extract-plugin
module.exports = {"main":"DataTableStyles_main__1q5E5","tableHeader":"DataTableStyles_tableHeader__3zsyg"};